import Vue from "vue";
import {AclInstaller, AclCreate, AclRule} from "vue-acl";
import VueCookies from "vue-cookies";
import router from "@/router";

Vue.use(AclInstaller);

let initialRole = "210";

let userInfo = VueCookies.isKey("userInfo") ? VueCookies.get("userInfo") : null;
// let userInfo = null;
// try{
// 	userInfo = userInfoText ? JSON.parse(userInfoText) : null;
// }
// catch(e){
// 	userInfo = null;
// }

if(userInfo && userInfo.userRole){
	initialRole = userInfo.userRole;
}

export default new AclCreate({
	initial: initialRole,
	notfound: "/",
	router,
	acceptLocalRules: true,
	globalRules: {
		sadmin: new AclRule("191").generate(),
		financesadmin: new AclRule("181").or("191").generate(),
		admin: new AclRule("161").or("191").generate(),
		financeadmin: new AclRule("181").or("161").or("191").generate(),
		accountmanager: new AclRule("131").or("161").or("191").generate(),
		financeaccountmanager: new AclRule("181").or("131").or("161").or("191").generate(),
		financecommercial: new AclRule("181").or("141").or("131").or("161").or("191").generate(),
		externcollaborator: new AclRule("171").or("131").or("161").or("191").generate(),
		noextern: new AclRule("181").or("141").or("131").or("161").or("191").generate(),
		commercial: new AclRule("141").or("131").or("161").or("191").generate(),
		clientdash: new AclRule("211").or("221").or("251").or("141").or("131").or("161").or("191").generate(),
		client: new AclRule("210").or("220").or("211").or("221").or("251").or("141").or("131").or("161").or("191").generate(),
	}
});
